import React from 'react';
import style from "./style.module.scss"
import { AgentTypes } from './types';

type Props = {
    handleRouteNavigation: (v: AgentTypes) => void
    selectedTab: string
    selectedAppType: string
}
const AgentSelector = ({ handleRouteNavigation, selectedTab, selectedAppType }: Props) => {
    return (
        <div className={style.agentSelector}>
            <div className={style.tabs}>
                <nav className={style.tabNav}>
                    <button
                        className={style.tabButton + ` ${selectedTab === 'workFlowAgents' ? style.tabButtonActive : ''}`}
                        onClick={() => handleRouteNavigation('workFlowAgents')}
                    >
                        Workflow Agent
                    </button>
                    <button
                        className={style.tabButton + ` ${selectedTab === 'knowledgeBaseAgents' ? style.tabButtonActive : ''}`}
                        onClick={() => handleRouteNavigation('knowledgeBaseAgents')}
                    >
                        Knowledge Base Agent
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default AgentSelector;